import { render, staticRenderFns } from "./CustomerByGender.vue?vue&type=template&id=1f93166e&"
import script from "./CustomerByGender.vue?vue&type=script&lang=js&"
export * from "./CustomerByGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports